import { render, staticRenderFns } from "./custom-button.vue?vue&type=template&id=0ae5382a&scoped=true"
import script from "./custom-button.vue?vue&type=script&lang=js"
export * from "./custom-button.vue?vue&type=script&lang=js"
import style0 from "./custom-button.vue?vue&type=style&index=0&id=0ae5382a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5382a",
  null
  
)

export default component.exports